//src/components/common/DateRangeInput.tsx
import React from 'react';
import './DateRangeInput.css';

interface DateRangeInputProps {
  dataInicio: string;
  setDataInicio: (value: string) => void;
  dataFim: string;
  setDataFim: (value: string) => void;
  theme: 'dark' | 'light';
  label?: string; // Opcional para texto dinâmico
}

const DateRangeInput: React.FC<DateRangeInputProps> = ({
  dataInicio,
  setDataInicio,
  dataFim,
  setDataFim,
  theme,
  label = 'Criado entre', // Default se não informado
}) => {
  return (
    <div className={`date-range-wrapper ${theme}`} style={{ '--label-text': `"${label}"` } as React.CSSProperties}>
      <input
        type="date"
        value={dataInicio}
        onChange={(e) => setDataInicio(e.target.value)}
        placeholder="Data Início"
        className="search-input data-inicio-input"
      />
      <input
        type="date"
        value={dataFim}
        onChange={(e) => setDataFim(e.target.value)}
        placeholder="Data Fim"
        className="search-input data-fim-input"
      />
    </div>
  );
};

export default DateRangeInput;